import { t } from 'ember-intl';

<template>
  <h1>{{t "syf.test_start_page"}}</h1>
</template>
